/* Armazém 11/2026 — /pages/curtidos: produtos curtidos no feed de vídeos (❤ do trilho), guardados no aparelho.
   Contrato (gravado por videos-feed.js — aqui só LIDO): localStorage.reels_likes =
     { "<reelId>": { handle, variant, title, image, price, at } } — ausente/corrompido = vazio.
   1º desenho só com o que está salvo (zero rede); depois /products/<handle>.js (endpoint nativo) atualiza
   preço e estoque — sempre textContent, nunca innerHTML com dado externo.
   "Escolher cor e tamanho" = quick view do tema (data-product-quickview, quick-view.js é global).
   × = descurte (apaga do localStorage e some o card). */
(function () {
  'use strict';
  if (window.customElements.get('liked-products')) return;

  var KEY = 'reels_likes';
  var HANDLE = /^[a-z0-9][a-z0-9-]*$/i; // handle válido da Shopify
  var REEL = /^[\w-]+$/; // id do Reel (vira #reel-<id>)
  var IMG = /^(https:)?\/\//; // capa só por URL absoluta (image_url do tema)

  function readLikes() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
    } catch (e) {
      return {};
    }
  }

  function writeLikes(likes) {
    try {
      localStorage.setItem(KEY, JSON.stringify(likes));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('reels:likes')); // bolinha do ❤ (curtidos-badge.js)
  }

  function money(cents) {
    var fmt = window.FoxThemeSettings && window.FoxThemeSettings.money_format;
    if (fmt && typeof window.formatMoney === 'function') return window.formatMoney(cents, fmt);
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  /* <strong>por</strong> <s>de</s> — mesmas classes do reel-price (reel-ui.css) */
  function setPrice(el, price, compare) {
    el.textContent = '';
    var b = document.createElement('strong');
    b.textContent = price;
    el.appendChild(b);
    if (compare) {
      var s = document.createElement('s');
      s.textContent = compare;
      el.appendChild(document.createTextNode(' '));
      el.appendChild(s);
    }
    el.hidden = !price;
  }

  class LikedProducts extends HTMLElement {
    connectedCallback() {
      this.root = this.dataset.root || '/';
      this.grid = this.querySelector('[data-grid]');
      this.tpl = this.querySelector('template[data-card]');
      this.likes = readLikes();
      this.addEventListener('click', this.onClick.bind(this));
      this.render();
    }

    /* ids válidos, do mais recente pro mais antigo */
    ids() {
      var likes = this.likes;
      return Object.keys(likes)
        .filter(function (id) {
          var it = likes[id];
          return REEL.test(id) && it && typeof it === 'object' && HANDLE.test(String(it.handle || ''));
        })
        .sort(function (a, b) {
          return String(likes[b].at || '').localeCompare(String(likes[a].at || ''));
        });
    }

    render() {
      var ids = this.ids();
      this.grid.textContent = '';
      this.updateCount(ids.length);
      if (!ids.length) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < ids.length; i++) frag.appendChild(this.card(ids[i], this.likes[ids[i]]));
      this.grid.appendChild(frag);
      var self = this;
      requestAnimationFrame(function () {
        // depois do 1º paint: preço/estoque frescos, 1 fetch por card
        ids.forEach(function (id) {
          self.refresh(id);
        });
      });
    }

    updateCount(n) {
      this.querySelector('[data-empty]').hidden = n > 0;
      var c = this.querySelector('[data-count]');
      c.hidden = n === 0;
      c.textContent = n + (n === 1 ? ' produto' : ' produtos');
    }

    card(id, it) {
      var variant = parseInt(it.variant, 10) || 0;
      var q = variant ? '?variant=' + variant : '';
      var url = this.root + 'products/' + it.handle + q;
      var el = this.tpl.content.firstElementChild.cloneNode(true);
      el.dataset.id = id;
      el.querySelectorAll('[data-link]').forEach(function (a) {
        a.href = url;
      });
      var img = el.querySelector('[data-img]');
      img.alt = String(it.title || '');
      if (IMG.test(String(it.image || ''))) img.src = it.image;
      else img.remove();
      el.querySelector('[data-title]').textContent = it.title || it.handle;
      setPrice(el.querySelector('[data-price]'), String(it.price || ''), '');
      el.querySelector('[data-buy]').setAttribute('data-product-quickview', it.handle + q);
      el.querySelector('[data-video]').href = (this.dataset.feed || this.root + 'pages/videos') + '#reel-' + id;
      return el;
    }

    refresh(id) {
      var it = this.likes[id];
      if (!it) return;
      var self = this;
      fetch(this.root + 'products/' + it.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw r.status;
          return r.json();
        })
        .then(function (p) {
          self.apply(id, p);
        })
        .catch(function (status) {
          if (status === 404) self.gone(id); // produto apagado/despublicado
        });
    }

    apply(id, p) {
      var el = this.grid.querySelector('[data-id="' + id + '"]');
      if (!el || !p || !Array.isArray(p.variants) || !p.variants.length) return;
      var want = parseInt(this.likes[id] && this.likes[id].variant, 10);
      var v =
        p.variants.filter(function (x) {
          return x.id === want;
        })[0] ||
        p.variants.filter(function (x) {
          return x.available;
        })[0] ||
        p.variants[0];
      setPrice(
        el.querySelector('[data-price]'),
        money(v.price),
        v.compare_at_price > v.price ? money(v.compare_at_price) : ''
      );
      var badge = el.querySelector('[data-soldout]');
      badge.textContent = p.available ? 'Opção esgotada' : 'Esgotado';
      badge.hidden = !!(p.available && v.available); // quick view deixa escolher outra opção
      el.classList.toggle('is-soldout', !p.available);
      if (p.title) el.querySelector('[data-title]').textContent = p.title;
    }

    gone(id) {
      var el = this.grid.querySelector('[data-id="' + id + '"]');
      if (!el) return;
      var badge = el.querySelector('[data-soldout]');
      badge.textContent = 'Indisponível';
      badge.hidden = false;
      el.classList.add('is-soldout');
      el.querySelector('[data-buy]').hidden = true;
    }

    onClick(e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn || !this.contains(btn)) return;
      var el = btn.closest('[data-id]');
      delete this.likes[el.dataset.id];
      writeLikes(this.likes);
      el.remove();
      this.updateCount(this.grid.children.length);
    }
  }

  /* Caixa "me avisa": aparece com ≥1 curtido; guarda o e-mail no aparelho e, se houver endpoint (função do robô),
     manda {email, produtos:[{reel, handle, variant, price}]} — é o que alimenta o aviso de preço/estoque. */
  var ALERTA = 'curtidos_alerta_email';
  function alertaInit(root) {
    var form = root.parentElement && root.parentElement.querySelector('[data-alerta]');
    if (!form) return;
    var ok = form.querySelector('[data-alerta-ok]');
    var okText = form.querySelector('[data-alerta-ok-text]');
    var row = form.querySelector('[data-alerta-form]');
    var err = form.querySelector('[data-alerta-error]');
    var input = form.querySelector('input[type="email"]');
    function pinta() {
      var likes = readLikes();
      var n = Object.keys(likes).length;
      form.hidden = n === 0;
      var email = '';
      try {
        email = localStorage.getItem(ALERTA) || '';
      } catch (e) {}
      var tem = !!email;
      row.hidden = tem;
      ok.hidden = !tem;
      if (tem) okText.textContent = 'Avisos ligados pra ' + email + ' (' + n + (n === 1 ? ' produto' : ' produtos') + ').';
    }
    function envia(email) {
      var likes = readLikes();
      var produtos = Object.keys(likes).map(function (id) {
        var l = likes[id] || {};
        return { reel: id, handle: l.handle || '', variant: l.variant || null, price: l.price || '' };
      });
      var url = form.dataset.endpoint;
      if (!url) return Promise.resolve();
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, produtos: produtos, pagina: location.pathname, at: new Date().toISOString() }),
        keepalive: true,
      }).catch(function () {});
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        err.hidden = false;
        input.focus();
        return;
      }
      err.hidden = true;
      try {
        localStorage.setItem(ALERTA, email);
      } catch (e2) {}
      envia(email);
      pinta();
    });
    var trocar = form.querySelector('[data-alerta-trocar]');
    if (trocar) {
      trocar.addEventListener('click', function () {
        try {
          localStorage.removeItem(ALERTA);
        } catch (e3) {}
        pinta();
        input.focus();
      });
    }
    document.addEventListener('reels:likes', pinta);
    pinta();
  }

  window.customElements.define('liked-products', LikedProducts);
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('liked-products');
    if (el) alertaInit(el);
  });
  if (document.readyState !== 'loading') {
    var el0 = document.querySelector('liked-products');
    if (el0) alertaInit(el0);
  }
})();
